import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MessageService } from 'primeng/api';
import { Cooeperative } from 'src/app/shared/models/cooperative';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';

@Component({
  selector: 'app-add-cooperatives',
  templateUrl: './add-cooperatives.component.html',
  styleUrl: './add-cooperatives.component.scss'
})

export class AddCooperativesComponent {
  item: Cooeperative = new Cooeperative();
  departementItems: any;
  categorieProduitItems: any;
  adminItems: any;
  user_reference: any;
  etatProduitItems: any;
  varieteItems: any;
  photoPreview: string | ArrayBuffer | null = null;
  visible: boolean = false;

  position: string = 'center';
  constructor(
    private modalService: NgbModal,
    private messageService: MessageService,
    private authService: AuthService,
    private fecthDataService: FecthDataService,
    private ngxService: NgxUiLoaderService,
    private localStorage: LocalStorageService,
    private paramService: ParameterService,
    private ngxservice: NgxUiLoaderService

  ) { }



  ngOnInit() {
    this.getPays();
    this.user_reference = this.localStorage.getUsers();
    console.log("this.user_reference", this.user_reference);
    this.getAdministrateur();
  }



  close() {

    this.modalService.dismissAll();
  }

  addCooperative() {
    if (!this.item.canSave()) {
      this.messageService.add({ severity: 'info', summary: "Ikena Cooperative", detail: this.item.getErrorMessage() });
      return;
    }
    else {
      this.ngxservice.start();
      this.paramService.addCooperative(this.item).subscribe(
        (response: any) => {
          this.ngxservice.stop();
          this.modalService.dismissAll();
          this.messageService.add({
            severity: 'success',
            summary: "Président de coopérative",
            detail: response.message,
          });
          this.fecthDataService.notifySeriviceCreated();
        },
        (error: any) => {
          this.ngxservice.stop();
          this.messageService.add({
            severity: 'error',
            summary: "Ikena Cooperative",
            detail: error,
          });
        }
      );
    }
  }

  getAdministrateur(){
    this.authService.getAdministrateur(this.user_reference?.data?.reference).subscribe(
      (response:any)=>{
        this.adminItems = response.data;
        console.log('la reponse du  webservice',this.adminItems);

      },
      (error:any)=>{
        console.log("une erreur est survenu",error);

      }
    )
  }

  getPays() {
    this.paramService.getPays().subscribe(

      (response: any) => {
        this.departementItems = response.data;
        console.log("this.departementItems", this.departementItems);
      },
      (error) => {
        console.log("une erreur est survenu", error);

      }

    );
  }


}
